import { render, staticRenderFns } from "./SectionTitleSub.vue?vue&type=template&id=6bfbddab&"
import script from "./SectionTitleSub.vue?vue&type=script&lang=js&"
export * from "./SectionTitleSub.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleSub.vue?vue&type=style&index=0&id=6bfbddab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports